import http from '../http'
import axios from 'axios'
const qiniu = {
    upload(model){
        return axios.post(`https://up.qbox.me`,model,{headers:{'Content-Types':'multipart/form-data'}})
    },
    getToken(filters){
        return http.get(`/work_order/tokenController/getToken`,{params:filters});
    }
}
export default qiniu;